const Home = () => import('@/views/home-view');
const Applications = () => import('@/views/application/applications-view');
const Campaigns = () => import('@/views/campaign/campaign-index-view');
const CampaignsCreate = () => import('@/views/campaign/campaign-create-view');
const ClientsCreate = () => import('@/views/client/client-create-view');
const ClientEdit = () => import('@/views/client/client-edit-view');
const AccountReactivation = () => import('@/views/account/account-reactivate-view');
const AccountSettings = () => import('@/views/account/settings/account-settings-view');
const AccountBilling = () => import('@/views/account/settings/account-billing-view');
const AccountBillingPromoCancel = () => import('@/views/account/settings/account-exit-survey-view');
const AccountIntegrationsSettings = () => import('@/views/account/settings/account-integrations-settings-view');
const AccountCustomizationSignature = () => import('@/views/account/settings/account-customization-signature-view');
const PartnerApplicationAccessClient = () => import('@/views/account/settings/partner-application-access-client-view');
const CampaignTemplates = () => import('@/views/template/template-index-view');
const Journey = () => import('@/views/journey/journey-index-view');
const JourneyTemplate = () => import('@/views/journey-template/journey-template-index-view');
const JourneyDetails = () => import('@/views/journey/journey-details-view');
const JourneyDesign = () => import('@/views/journey/journey-design-view');
const JourneyGraphicEmailDesign = () => import('@/views/journey/journey-graphic-email-design-view');
const JourneyDetailsSent = () => import('@/views/journey/journey-details-sent-view');
const JourneyDetailsUnsubscribed = () => import('@/views/journey/journey-details-unsubscribed-view');
const JourneyDetailsOpens = () => import('@/views/journey/journey-details-opens-view');
const JourneyDetailsClicks = () => import('@/views/journey/journey-details-clicks-view');
const JourneyDetailsBounces = () => import('@/views/journey/journey-details-bounces-view');
const EmailDesign = () => import('@/views/email/email-design-view');
const EmailTemplates = () => import('@/views/email/email-templates-view');
const AppointmentRequests = () => import('@/views/appointment-requests/appointment-requests-view');
const EmailsScheduled = () => import('@/views/email/emails-scheduled-view');
const CampaignsUnsubscribe = () => import('@/views/campaign/campaign-unsubscribe-view');
const TemplateCreate = () => import('@/views/template/template-create-view');
const Clients = () => import('@/views/client/client-index-view');
const Agencies = () => import('@/views/agency/agency-index-view');
const SubscriptionPlan = () => import('@/views/subscription-plan/subscription-plan-view');
const MasterAgencies = () => import('@/views/master-agency/master-agency-index-view');
const MasterAgencyDashboard = () => import('@/views/master-agency/master-agency-dashboard-view');
const AgencyDashboard = () => import('@/views/agency/agency-dashboard-view');
const AgencyLeadQuotas = () => import('@/views/agency/agency-lead-quotas-view');
const MarketingDashboard = () => import('@/views/client/client-marketing-view');
const SalesDashboard = () => import('@/views/client/client-sales-view');
const SalesTeam = () => import('@/views/client/client-sales-team-view');
const Contacts = () => import('@/views/contact/contact-index-view');
const QualifiedLeads = () => import('@/views/contact/contact-qualified-leads-view');
const CompanyQualifiedLeads = () => import('@/views/company/company-qualified-leads-view');
const FormSubmissions = () => import('@/components/archived-components/form-submissions-view');
const ActivityMeeting = () => import('@/views/activity/activity-meeting-view');
const Video = () => import('@/components/archived-components/video-index-view');
const ListLess = () => import('@/views/contact/contact-listless-view');
const ContactAssigned = () => import('@/views/contact/contact-assigned-view');
const PartnerQualifiedLeads = () => import('@/views/contact/contact-partner-qualified-leads-view');
const PartnerMeetings = () => import('@/views/activity/partner-meetings-view');
const MyContacts = () => import('@/views/contact/contact-my-contacts-view');
const MyQualifiedLeads = () => import('@/views/contact/contact-my-qualified-leads-view');
const Lists = () => import('@/views/list/list-index-view');
const RegisteredDealIndex = () => import('@/views/registered-deal/registered-deal-index-view');
const Companies = () => import('@/views/company/company-index-view');
const CompanyAccounts =() => import('@/views/company/company-accounts-index-view');
const Adoption = () => import('@/views/home/home-adoption-view');
const CollateralIndexView = () => import('@/views/library/collateral-index-view');
const Tasks = () => import('@/views/task/task-index-view');
const MyTasks = () => import('@/views/task/my-task-index-view')
const ServiceIndex = () => import('@/views/service/service-index-view');
const AccountCustomizationCompanyType = () => import('@/views/account/settings/account-customization-company-types-view');
const AccountCustomizationOpportunityType = () => import('@/views/account/settings/account-customization-opportunity-type-view');
const AccountCustomizationOpportunityStatus = () => import('@/views/account/settings/account-customization-opportunity-status-view');
const AccountCustomizationContactStatus = () => import('@/views/account/settings/account-customization-contact-status-view');
const AccountCustomizationOpportunityStages = () => import('@/views/account/settings/account-customization-opportunity-stages-view');
const AccountCustomizationVerticals = () => import('@/views/account/settings/account-customization-verticals-view');
const AccountCustomizationGlobalCategories = () => import('@/views/account/settings/account-customization-global-categories-view');
const AccountCustomizationCustomContactFields = () => import('@/views/account/settings/account-customization-custom-contact-fields-view');
const AccountCustomizationCustomCompanyFields = () => import('@/views/account/settings/account-customization-custom-company-fields-view');
const AccountCustomizationCustomLogActivities = () => import('@/views/account/settings/account-customization-custom-log-activities-view');
const AccountCustomizationCustomOpportunityFields = () => import('@/views/account/settings/account-customization-custom-opportunity-fields-view');
const AccountCustomizationCustomPartnerFields = () => import('@/views/account/settings/account-customization-custom-partner-fields-view');
const AccountCustomizationCustomInsertTags = () => import('@/views/account/settings/account-customization-custom-insert-tags-view');
const Users = () => import('@/views/user/user-index-view');
const AllUsers = () => import('@/views/user/all-user-index-view')
const UsersCreate = () => import('@/views/user/user-create-view');
const AccountEmailAuthentication = () => import('@/views/account/settings/account-email-authentication-view');
const DkimIntegration = () => import('@/views/account/integrations/dkim-integration-view');
const FormIntegration = () => import('@/views/account/integrations/form-integration-view');
const AutotaskIntegration = () => import('@/views/account/integrations/autotask-integration-view');
const Office365Integration = () => import('@/views/account/integrations/office-365-integration-view');
const GoogleAnalyticsIntegration = () => import('@/views/account/integrations/google-analytics-integration-view');
const HubSpotConnect = () => import('@/views/account/integrations/hubspot-connect-view');
const HubSpot = () => import('@/views/account/integrations/hubspot-view');
const WistiaIntegration = () => import('../views/account/integrations/wistia-integration-view');
const CampaignMonitorIntegration = () => import('@/views/account/integrations/campaign-monitor-integration-view');
const CampaignDetail = () => import('../views/campaign/campaign-details-view');
const NewContactDetail = () => import('@/views/contact/new-contact-details-view');
const OrganizationPartnerEnablement = () => import('@/views/organization/organization-partner-enablement-view');
const EmailAnalytics = () => import('@/views/email/email-analytics-view');
const AccountForgotPassword = () => import('@/views/account/account-forgot-password-view');
const AccountGateway = () => import('@/views/account/account-gateway-view');
const AccountResetPasswordConfirmation = () => import('@/views/account/account-reset-password-confirmation-view');
const AccountResetPassword = () => import('@/views/account/account-reset-password-view');
const AccountForgotPasswordConfirmation = () => import('@/views/account/account-forgot-password-confirmation-view');
const AccountConfirmEmail = () => import('@/views/account/account-confirm-email-view');
const AccountCreateSuccess = () => import('@/views/account/account-create-success-view');
const AccountConfirmationRequired = () => import('@/views/account/account-confirmation-required-view');
const AccountResendConfirmationEmail = () => import('@/views/account/account-resend-confirmation-email-view');
const AccountProSignup = () => import('@/views/account/account-pro-signup-view');
const JourneyAccountUpgrade = () => import('@/views/journey/journey-account-upgrade-view');
const MarketingPlanAccountUpgrade = () => import('@/views/marketing-plan/marketing-plan-account-upgrade-view');
const EmailPreview = () => import('@/views/email/email-preview-view');
const ContactMerge = () => import('@/views/contact/contact-merge-view'); 
const CompanyDetail = () => import('@/views/company/company-details-view');
const List = () => import('@/views/list/list-detail-view');
const NextSteps = () => import('@/views/account/account-next-steps-view');
const PrivacyPolicy = () => import('@/views/account/account-privacy-policy-view');
const AiTransparency = () => import('@/views/account/account-ai-transparency-view');
const ProfilePersonalSettings = () => import('@/views/account/profile/profile-settings-view');
const ProfileEmailSettings = () => import('@/views/account/profile/profile-email-view');
const ProfileUserSettings = () => import('@/views/account/profile/user-profile-settings-view');
const TermsOfService = () => import('@/views/account/account-terms-of-service-view');
const DataProcessingAgreement = () => import('@/views/account/account-dpa-view');
const CookiePolicy = () => import('@/views/account/account-cookie-policy-view');
const SalesPersonDetail = () => import('@/views/client/client-sales-professional-view');
const SocialAnalytics = () => import('@/views/client/client-social-analytics-view');
const ContactsUnsubscribed = () => import('@/views/contact/contact-unsubscribed-view');
const TemplateEdit = () => import('@/views/template/template-edit-view');
const NotFound = () => import('@/views/error/error-page-not-found-view');
const Unauthorized = () => import('@/views/error/error-page-unauthorized');
const MarketingPlans = () => import('@/views/marketing-plan/marketing-plan-index-view');
const MarketingPlanTemplates = () => import('@/views/marketing-plan-template/marketing-plan-template-index-view');
const MarketingPlanCalendar = () => import('@/views/marketing-plan/marketing-plan-calendar-view');
const MarketingPlanTemplateCalendar = () => import('@/views/marketing-plan-template/marketing-plan-template-calendar-view');
const ReportAgencyRegisteredDealsReport = () => import('@/views/report/report-agency-registered-deal-report-view');
const ReportAgencyPartnerLeadsReport = () => import('@/views/report/report-agency-partner-leads-view');
const ReportAgencyPartnerResourcesReport = () => import('@/views/report/report-agency-partner-resources-view');
const ReportAgencyPartnerResourcesSolutionsReport = () => import('@/views/report/report-agency-partner-resources-solutions-view.vue');
const ReportAgencyTopPartners = () => import('@/views/report/report-agency-top-partners-view');
const ReportAgencyCampaigns = () => import('@/views/report/report-agency-campaigns-report-view');
const ReportAgencyUsageReport = () => import('@/views/report/report-agency-usage-view');
const ReportMarketing = () => import('@/views/report/report-marketing-view');
const ReportMarketingLeadsReport = () => import('@/views/report/report-marketing-leads-report-view');
const ReportAgencyPartnerSurveysReport = () => import('@/views/report/report-agency-partner-surveys-view');
const ReportMarketingWebsiteAnalyticsReport = () => import('@/views/report/report-marketing-website-analytics-view');
const ReportMarketingCampaignsReport = () => import('@/views/report/report-marketing-campaigns-report-view');
const ReportMarketingLandingPagesReport = () => import('@/views/report/report-marketing-landing-pages-report-view');
const ReportMarketingMarketingPlansReport = () => import('@/views/report/report-marketing-marketing-plans-report-view');
const ReportMarketingFormSubmissionsReport = () => import('@/views/report/report-marketing-form-submissions-report-view');
const ReportMDFIndex = () => import('@/views/mdf/mdf-report-index-view');
const ReportSales = () => import('@/views/report/report-sales-view');
const ReportSalesTeamActivity = () => import('@/views/report/report-sales-team-activity-view');
const ReportSalesClientSolutionsRoadmap = () => import('@/views/report/report-sales-client-solutions-roadmap-view');
const OpportunitiesDashboard = () => import('@/views/deals/opportunities-dashboard-view');
const ReportSalesPerformanceReport = () => import('@/views/report/report-sales-performance-report-view');
const ReportMasterAgencyCampaigns = () => import('@/views/report/report-master-agency-campaigns-report-view');
const ReportMasterAgency = () => import('@/views/report/report-master-agency-view');
const ReportMasterAgencyRegisteredDealsReport = () => import('@/views/report/report-master-agency-registered-deal-report-view');
const ReportMasterAgencyPartnerResourcesReport = () => import('@/views/report/report-master-agency-partner-resources-report-view');
const ReportMasterAgencyLeadsReport = () => import('@/views/report/report-master-agency-leads-report-view');
const ReportMasterAgencyTopAgencies = () => import('@/views/report/report-master-agency-top-agencies-view');
const ReportMasterAgencyTopPartners = () => import('@/views/report/report-master-agency-top-partners-view');
const ReportIndex = () => import('@/views/report/report-index-view');
const ReportsScheduled = () => import('@/views/report/reports-scheduled-view');
const ReportAgencyScheduledReports = () => import('@/views/report/report-agency-scheduled-view');
const ReportOpportunities = () => import('@/views/report/report-opportunities-salesperson-dashboard-view');
const UserGuide = () => import('@/views/account/profile/user-guide-view');
const AccountPhoneNumbers = () => import('@/views/account/settings/account-phone-numbers-view');
const Leads = () => import('@/views/contact/contact-leads-view');
const Updates = () => import('@/views/updates/updates-view');
const AccountPrivacyEnabledView = () => import('@/views/account/settings/account-privacy-enabled-view');
const ExitSurveyResultsView = () => import('@/views/organization/exit-survey-results-view');

const ContactsBounced = () => import('@/views/contact/contact-bounced-view');

import store from '@/stores/index';
import connectWiseRoutes from '@/routes/integrations/connectwise/index';
import ThirdPartyIdentityProvider from '@/routes/third-party/connectwise/index';
import HaloPSARoutes from '@/routes/integrations/halopsa/index';
import salesforceRoutes from '@/routes/integrations/salesforce/index';
import autotaskRoutes from '@/routes/integrations/autotask/index';
import syncroRoutes from '@/routes/integrations/syncro/index';
import collateralBuildsRoutes from '@/routes/collateral-builds/index';
import landingPagesRoutes from '@/routes/landing-pages/index';
import socialMediaRoutes from '@/routes/social-media/index';
import designStudio from '@/routes/design-studio/index';
import AccountRoutes from '@/routes/account';
import AuthRoutes from '@/routes/auth';
import DocumentsRoutes from '@/routes/documents/index';
import OpenAPIRoutes from '@/routes/open-api/index';
import MarketplaceRoutes from '@/routes/marketplace/index'
import kaseyaRoutes from '@/routes/integrations/kaseya/index'
import HubSpotRoutes from '@/routes/integrations/hubspot/index';
import MDFRoutes from '@/routes/mdf/index'
import PartnerSurveysRoutes from '@/routes/partner-surveys/index'
import SolutionsRoutes from '@/routes/solutions/index'

export default [
    ...connectWiseRoutes,
    ...ThirdPartyIdentityProvider,
    ...HaloPSARoutes,
    ...salesforceRoutes,
    ...autotaskRoutes,
    ...syncroRoutes,
    ...collateralBuildsRoutes,
    ...landingPagesRoutes,
    ...socialMediaRoutes,
    ...designStudio,
    ...AccountRoutes,
    ...AuthRoutes,
    ...DocumentsRoutes,
    ...OpenAPIRoutes,
    ...MarketplaceRoutes,
    ...kaseyaRoutes,
    ...HubSpotRoutes,
    ...MDFRoutes,
    ...PartnerSurveysRoutes,
    ...SolutionsRoutes,
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            isUiShown: true,
            pageClass: 'home-page',
            pageTitle: 'Home'
        }
    },
    {
        path: '/Adoption',
        name: 'Adoption',
        component: Adoption,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'home-adoption-page',
            pageTitle: 'Adoption'
        }
    },
    {
        path: '/PartnerEnablement',
        name: 'PartnerEnablement',
        component: OrganizationPartnerEnablement,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'organization-partner-enablement-page',
            pageTitle: 'Partner Enablement'
        }
    },
    {
        path: '/EmailAnalytics',
        name: 'EmailAnalytics',
        component: EmailAnalytics,
        meta: {
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'email-analytics-page',
            pageTitle: 'Email Analytics'
        }
    },
    {
        path: '/Clients/:clientId/EmailAnalytics',
        name: 'ClientEmailAnalytics',
        component: EmailAnalytics,
        meta: {
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'email-analytics-page',
            pageTitle: 'Email Analytics'
        }
    },
    {
        path: '/Applications',
        name: 'Applications',
        component: Applications,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'applications-page',
            pageTitle: 'Applications'
        }
    },
    {
        path: '/Clients',
        name: 'Clients',
        component: Clients,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'clients-index-page',
            pageTitle: 'Partners'
        }
    },
    {
        path: '/Agencies/:agencyId/Clients',
        name: 'AgencyClients',
        component: Clients,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'clients-index-page',
            pageTitle: 'Vendor Partners'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/TopPartners',
        name: 'AgencyReportTopPartners',
        component: ReportAgencyTopPartners,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'report-agency-top-partners-page',
            pageTitle: 'Vendor Top Partners Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/TopPartners',
        name: 'ReportTopPartners',
        component: ReportAgencyTopPartners,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'report-agency-top-partners-page',
            pageTitle: 'Top Partners Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/Campaigns',
        name: 'ParentReportAgencyCampaigns',
        component: ReportAgencyCampaigns,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'report-agency-campaigns-page',
            pageTitle: 'Partner Campaigns Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/AgencyCampaigns',
        name: 'ReportAgencyCampaigns',
        component: ReportAgencyCampaigns,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'report-agency-campaigns-page',
            pageTitle: 'Partner Campaigns Report'
        }
    },
    {
        path: '/MasterAgencies',
        name: 'MasterAgencies',
        component: MasterAgencies,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'master-agencies-index-page',
            pageTitle: 'Master Agencies'
        }
    },
    {
        path: '/SubscriptionPlans',
        name: 'SubscriptionPlan',
        component: SubscriptionPlan,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'subscription-plan-index-page',
            pageTitle: 'Subscription Plans'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Dashboard',
        name: 'MasterAgencyDashboard',
        component: MasterAgencyDashboard,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'master-agencies-dashboard-page',
            pageTitle: 'Master Agency Dashboard'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Agencies',
        name: 'MasterAgencyAgencies',
        component: Agencies,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'agency-index-page',
            pageTitle: 'Master Agency Vendors'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports',
        name: 'ParentReportMasterAgency',
        component: ReportMasterAgency,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'reports-master-agency-page',
            pageTitle: 'Master Agency Reports'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/Campaigns',
        name: 'ParentReportMasterAgencyCampaigns',
        component: ReportMasterAgencyCampaigns,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-campaigns-page',
            pageTitle: 'Master Agency Campaigns Report'
        }
    },
    {
        path: '/Reports/MasterAgencyCampaigns',
        name: 'ReportMasterAgencyCampaigns',
        component: ReportMasterAgencyCampaigns,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-campaigns-page',
            pageTitle: 'Campaigns Report'
        }
    },
    {
        path: '/Agencies',
        name: 'Agencies',
        component: Agencies,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'agencies-index-page',
            pageTitle: 'Vendors'
        }
    },
    {
        path: '/Agencies/:agencyId/Dashboard',
        name: 'AgencyDashboard',
        component: AgencyDashboard,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'agency-dashboard-page',
            pageTitle: 'Vendor Dashboard'
        }
    },
    {
        path: '/Clients/Create',
        name: 'ClientsCreate',
        component: ClientsCreate,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'clients-create-page',
            pageTitle: 'Create a Client'
        }
    },
    {
        path: '/Agencies/:agencyId/Account/Users',
        name: 'AgencyUsers',
        component: Users,
        meta: {
            isUiShown: true,
            type: 'agency',
            subtype: 'account',
            pageClass: 'users-index-page',
            pageTitle: 'Vendor Users'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAgencyAdmin &&
                !store.getters.isMasterAgencyUser &&
                !store.getters.isOrganizationUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Account/Users',
        name: 'MasterAgencyAgenciesUsers',
        component: Users,
        meta: {
            isUiShown: true,
            type: 'master-agency',
            subtype: 'account',
            pageClass: 'master-agency-users-page',
            pageTitle: 'Master Agency Users'
        }
    },
    {
        path: '/Users/Create',
        name: 'UsersCreate',
        component: UsersCreate,
        meta: {
            type: 'client',
            isUiShown: false,
            pageClass: 'users-create-page',
            pageTitle: 'Create a User'
        }
    },
    {
        path:'/Users/:userId/Profile',
        name: 'UserProfile',
        component: ProfileUserSettings,
        meta: {
            type: 'general',
            subtype: 'profile',
            isUiShown: true,
            pageClass: 'user-profile-settings-page',
            pageTitle: 'Profile'
        },
        beforeEnter: (to, from, next) => {
            var isClientAdmin = store.getters.isAdmin && store.getters.isClientUser;

            if (!isClientAdmin &&
                !store.getters.isAgencyAdmin &&
                !store.getters.isMasterAgencyUser &&
                !store.getters.isOrganizationUser) {
                
                next('/Unauthorized');
                
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Created',
        name: 'AccountCreated',
        component: AccountCreateSuccess,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'account-create-success-page',
            pageTitle: 'Account Created'
        }
    },
    {
        path: '/Clients/:clientId/Edit',
        name: 'ClientEdit',
        component: ClientEdit,
        meta: {
            type: 'Organization',
            isUiShown: true,
            pageClass: 'clients-edit-page',
            pageTitle: 'Edit Partner'
        }
    },
    {
        path: '/Marketing',
        name: 'MarketingDashboard',
        component: MarketingDashboard,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'clients-marketing-page',
            pageTitle: 'Marketing Dashboard'
        }
    },
    {
        path: '/Clients/:clientId/SocialAnalytics',
        name: 'ClientSocialAnalytics',
        component: SocialAnalytics,
        meta: {
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'client-social-analytics-page',
            pageTitle: 'Partner Social Analytics'
        }
    },
    {
        path: '/SocialAnalytics',
        name: 'SocialAnalytics',
        component: SocialAnalytics,
        meta: {
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'client-social-analytics-page',
            pageTitle: 'Social Analytics'
        }
    },
    {
        path: '/Clients/:clientId/Marketing',
        name: 'ClientsMarketingDashboard',
        component: MarketingDashboard,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'clients-marketing-page',
            pageTitle: 'Marketing Dashboard'
        }
    },
    {
        path: '/Sales',
        name: 'SalesDashboard',
        component: SalesDashboard,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'clients-sales-page',
            pageTitle: 'Sales Dashboard'
        }
    },
    {
        path: '/Clients/:clientId/Sales',
        name: 'ClientsSalesDashboard',
        component: SalesDashboard,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'clients-sales-page',
            pageTitle: 'Sales Dashboard'
        }
    },
    {
        path: '/MyTasks',
        name: 'MyTasks',
        component: MyTasks,
        meta: {
            type: 'client',
            subtype: 'tasks',
            isUiShown: true,
            pageClass: 'tasks-page',
            pageTitle: 'Tasks'
        }
    },

    {
        path: '/Tasks',
        name: 'Tasks',
        component: Tasks,
        meta: {
            type: 'client',
            subtype: 'tasks',
            isUiShown: true,
            pageClass: 'tasks-page',
            pageTitle: 'Tasks'
        }
    },
    {
        path: '/Clients/:clientId/Tasks',
        name: 'ClientsTasks',
        component: Tasks,
        meta: {
            type: 'client',
            subtype: 'tasks',
            isUiShown: true,
            pageClass: 'tasks-page',
            pageTitle: 'Tasks'
        }
    },
    {
        path: '/MyQualifiedLeads',
        name: 'MyQualifiedLeads',
        component: MyQualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'contacts-myqualifiedleads-page',
            pageTitle: 'My Qualified Leads'
        }
    },
    {
        path: '/Clients/:clientId/MyQualifiedLeads',
        name: 'ClientsMyQualifiedLeads',
        component: MyQualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'contacts-myqualifiedleads-page',
            pageTitle: 'My Qualified Leads'
        }
    },
    {
        path: '/Leads',
        name: 'Leads',
        component: Leads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'leads-page',
            pageTitle: 'Leads'
        }
    },

    {
        path: '/Clients/:clientId/Leads',
        name: 'ClientsLeads',
        component: Leads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'leads-page',
            pageTitle: 'Leads'
        }
    },
    {
        path: '/MyContacts',
        name: 'MyContacts',
        component: MyContacts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-mycontacts-page',
            pageTitle: 'My Contacts'
        }
    },
    {
        path: '/Clients/:clientId/MyContacts',
        name: 'ClientsMyContacts',
        component: MyContacts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-mycontacts-page',
            pageTitle: 'My Contacts'
        }
    },
    {
        path: '/Library',
        name: 'Library',
        component: CollateralIndexView,
        meta: {
            subtype: 'library',
            isUiShown: true,
            pageClass: 'library-index-page',
            pageTitle: 'Collateral'
        }
    },
    {
        path: '/Clients/:clientId/Library',
        name: 'ClientsLibrary',
        component: CollateralIndexView,
        meta: {
            type: 'client',
            subtype: 'library',
            isUiShown: true,
            pageClass: 'library-index-page',
            pageTitle: 'Collateral'
        }
    },
    {
        path: '/Agencies/:agencyId/Library',
        name: 'AgencyLibrary',
        component: CollateralIndexView,
        meta: {
            isUiShown: true,
            subtype: 'library',
            pageClass: 'library-index-page',
            pageTitle: 'Vendor Collateral'
        }
    },
    {
        path: '/Campaigns',
        name: 'Campaigns',
        component: Campaigns,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'clients-index-page',
            pageTitle: 'Campaigns'
        }
    },
    {
        path: '/Clients/:clientId/Campaigns',
        name: 'ClientsCampaigns',
        component: Campaigns,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'clients-index-page',
            pageTitle: 'Campaigns'
        }
    },
    {
        path: '/Campaigns/Create',
        name: 'CampaignsCreate',
        component: CampaignsCreate,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'campaigns-create-page',
            pageTitle: 'Campaign Creation'
        }
    },
    {
        path: '/Clients/:clientId/Campaigns/Create',
        name: 'ClientsCampaignsCreate',
        component: CampaignsCreate,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'campaigns-create-page',
            pageTitle: 'Campaign Creation'
        }
    },
    {
        path: '/Campaigns/Templates',
        name: 'CampaignTemplates',
        component: CampaignTemplates,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'templates-index-page',
            pageTitle: 'Graphical Email Templates'
        }
    },
    {
        path: '/Agencies/:agencyId/Campaigns/Templates',
        name: 'AgencyCampaignTemplates',
        component: CampaignTemplates,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'templates-index-page',
            pageTitle: 'Vendor Graphical Email Templates'
        }
    },
    {
        path: '/Emails/Scheduled',
        name: 'EmailsScheduled',
        component: EmailsScheduled,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'emails-scheduled-page',
            pageTitle: 'Scheduled Emails'
        }
    },
    {
        path: '/Clients/:clientId/Emails/Scheduled',
        name: 'ClientsEmailsScheduled',
        component: EmailsScheduled,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'emails-scheduled-page',
            pageTitle: 'Scheduled Emails'
        }
    },
    {
        path: '/LeadQuotas',
        name: 'LeadQuotas',
        component: AgencyLeadQuotas,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'lead-quotas-index-page',
            pageTitle: 'Lead Quotas'
        }
    },
    {
        path: '/Agencies/:agencyId/LeadQuotas',
        name: 'AgencyLeadQuotas',
        component: AgencyLeadQuotas,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'lead-quotas-index-page',
            pageTitle: 'Lead Quotas'
        }
    },
    {
        path: '/PartnerQualifiedLeads',
        name: 'PartnerQualifiedLeads',
        component: PartnerQualifiedLeads,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'contact-partner-leads-page',
            pageTitle: 'Partner Leads'
        }
    },
    {
        path: '/Agencies/:agencyId/PartnerQualifiedLeads',
        name: 'AgencyPartnerQualifiedLeads',
        component: PartnerQualifiedLeads,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'contact-partner-leads-page',
            pageTitle: 'Partner Leads'
        }
    },
    {
        path: '/PartnerMeetings',
        name: 'PartnerMeetings',
        component: PartnerMeetings,
        meta: {
            isUiShown: true,
            pageClass: 'partner-meetings-page',
            pageTitle: 'Partner Meetings'
        }
    },
    {
        path: '/Agencies/:agencyId/PartnerMeetings',
        name: 'AgencyPartnerMeetings',
        component: PartnerMeetings,
        meta: {
            isUiShown: true,
            pageClass: 'partner-meetings-page',
            pageTitle: 'Partner Meetings'
        }
    },
    {
        path: '/Emails/Templates',
        name: 'EmailTemplates',
        component: EmailTemplates,
        meta: {
            isUiShown: true,
            subtype: 'marketing',
            pageClass: 'email-templates-index-page',
            pageTitle: 'Non-Graphical Email Templates'
        }
    },
    {
        path: '/EmailTemplates/:emailTemplateId/Preview',
        name: 'EmailTemplatePreview',
        component: EmailPreview,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Messages/:messageId/Preview',
        name: 'MessagePreview',
        component: EmailPreview,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/JourneySteps/:journeyStepId/Preview',
        name: 'JourneyStepPreview',
        component: EmailPreview,
        meta: {
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Agencies/:agencyId/Emails/Templates',
        name: 'AgencyEmailTemplates',
        component: EmailTemplates,
        meta: {
            isUiShown: true,
            subtype: 'marketing',
            pageClass: 'email-templates-index-page',
            pageTitle: 'Non-Graphical Email Templates'
        }
    },
    {
        path: '/Clients/:clientId/Emails/Templates',
        name: 'ClientsEmailTemplates',
        component: EmailTemplates,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'marketing',
            pageClass: 'email-templates-index-page',
            pageTitle: 'Non-Graphical Email Templates'
        }
    },
    {
        path: '/Clients/:clientId/Appointments',
        name: 'Appointments',
        component: AppointmentRequests,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'sales',
            pageClass: 'appointment-requests-view',
            pageTitle: 'Generate Appointments'
        }
    },
    {
        path: '/Appointments',
        name: 'Appointments',
        component: AppointmentRequests,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'sales',
            pageClass: 'appointment-requests-view',
            pageTitle: 'Generate Appointments'
        }
    },
    {
        path: '/ExitSurveyResults',
        name: 'ExitSurveyResults',
        component: ExitSurveyResultsView,
        meta: {
            isUiShown: true,
            type: 'organization',
            pageClass: 'exit-survey-results-view',
            pageTitle: 'Exit Surveys'
        }
    },
    {
        path: '/Document/Emails/:documentId/Preview',
        name: 'EmailEditPreview',
        component: EmailPreview,
        meta: {
            subtype: 'sales',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Clients/:clientId/Campaigns/Templates',
        name: 'ClientsCampaignTemplates',
        component: CampaignTemplates,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'templates-index-page',
            pageTitle: 'Graphical Email Templates'
        }
    },
    {
        path: '/Clients/:clientId/Journeys',
        name: 'ClientsJourney',
        component: Journey,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-index-page',
            pageTitle: 'Journey'
        }
    },
    {
        path: '/Journeys',
        name: 'Journey',
        component: Journey,
        meta: {
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-index-page',
            pageTitle: 'Journey'
        }
    },
    {
        path: '/Agencies/:agencyId/JourneyTemplates',
        name: 'AgencyJourneyTemplate',
        component: JourneyTemplate,
        meta: {
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-template-index-page',
            pageTitle: 'Journey Templates'
        }
    },
    {
        path: '/JourneyTemplates',
        name: 'JourneyTemplate',
        component: JourneyTemplate,
        meta: {
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-template-index-page',
            pageTitle: 'Journey Template'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Journeys/:journeyId/Details',
        name: 'JourneyDetails',
        component: JourneyDetails,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-page',
            pageTitle: 'Journey Details'
        }
    },
    {
        path: '/Account/Upgrade/Journeys',
        name: 'JourneyAccountUpgrade',
        component: JourneyAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-journey-page',
            pageTitle: 'Account Upgrade Journey '
        }
    },
    {
        path: '/Clients/:clientId/Account/Upgrade/Journeys',
        name: 'ClientJourneyAccountUpgrade',
        component: JourneyAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-journey-page',
            pageTitle: 'Account Upgrade Journey '
        }
    },
    {
        path: '/Campaigns/:campaignId/Design',
        name: 'CampaignDesign',
        component: EmailDesign,
        meta: {
            type: 'client',
            isUiShown: false,
            pageClass: 'email-design-page',
            pageTitle: 'Graphical Email Design'
        }
    },
    {
        path: '/CampaignTemplates/:campaignTemplateId/Design',
        name: 'CampaignTemplateDesign',
        component: EmailDesign,
        meta: {
            isUiShown: false,
            pageClass: 'email-design-page',
            pageTitle: 'Graphical Email Design'
        }
    },
    {
        path: '/Journeys/:journeyId/Design',
        name: 'JourneyDesign',
        component: JourneyDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-design-page',
            pageTitle: 'Journey Design'
        }
    },
    {
        path: '/Journeys/:journeyId/Preview',
        name: 'JourneyPreview',
        component: JourneyDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-design-page',
            pageTitle: 'Journey Preview'
        }
    },
    {
        path: '/JourneyTemplates/:journeyTemplateId/Preview',
        name: 'JourneyTemplatePreview',
        component: JourneyDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-design-page',
            pageTitle: 'Journey Template Preview'
        }
    },
    {
        path: '/JourneyTemplates/:journeyTemplateId/Design',
        name: 'JourneyTemplateDesign',
        component: JourneyDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-design-page',
            pageTitle: 'Journey Template Design'
        }
    },
    {
        path: '/Journeys/:journeyId/JourneySteps/:journeyStepId/EmailDesign',
        name: 'JourneyGraphicEmailDesign',
        component: JourneyGraphicEmailDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-graphic-email-design-page',
            pageTitle: 'Journey Graphic Email Design'
        }
    },
    {
        path: '/JourneyTemplates/:journeyTemplateId/JourneySteps/:journeyStepId/EmailDesign',
        name: 'JourneyTemplateGraphicEmailDesign',
        component: JourneyGraphicEmailDesign,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: false,
            pageClass: 'journey-graphic-email-design-page',
            pageTitle: 'Journey Graphic Email Design'
        }
    },
    {
        path: '/Journeys/:journeyId/Details/Sent',
        name: 'JourneyDetailsSent',
        component: JourneyDetailsSent,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-sent-page',
            pageTitle: 'Journey Details Sent'
        }
    },
    {
        path: '/Journeys/:journeyId/Details/Unsubscribed',
        name: 'JourneyDetailsUnsubscribed',
        component: JourneyDetailsUnsubscribed,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-unsubscribed-page',
            pageTitle: 'Journey Details Unsubscribed'
        }
    },
    {
        path: '/Journeys/:journeyId/Details/Opens',
        name: 'JourneyDetailsOpens',
        component: JourneyDetailsOpens,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-opens-page',
            pageTitle: 'Journey Details Opens'
        }
    },
    {
        path: '/Journeys/:journeyId/Details/Clicks',
        name: 'JourneyDetailsClicks',
        component: JourneyDetailsClicks,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-clicks-page',
            pageTitle: 'Journey Details Clicks'
        }
    },
    {
        path: '/Journeys/:journeyId/Details/Bounces',
        name: 'JourneyDetailsBounces',
        component: JourneyDetailsBounces,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'journey-details-bounces-page',
            pageTitle: 'Journey Details Bounces'
        }
    },
    {
        path: '/Unsubscribe',
        name: 'CampaignsUnsubscribe',
        component: CampaignsUnsubscribe,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'campaigns-unsubscribe-page',
            pageTitle: 'Unsubscribe'
        }
    },
    {
        path: '/Lists',
        name: 'Lists',
        component: Lists,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'lists-index-page',
            pageTitle: 'Lists'
        }
    },
    {
        path: '/Clients/:clientId/Lists',
        name: 'ClientsLists',
        component: Lists,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'lists-index-page',
            pageTitle: 'Lists'
        }
    },
    {
        path: '/QualifiedLeads',
        name: 'QualifiedLeads',
        component: QualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'qualified-leads-page',
            pageTitle: 'Qualified Leads'
        }
    },
    {
        path: '/Clients/:clientId/QualifiedLeads',
        name: 'ClientsQualifiedLeads',
        component: QualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'qualified-leads-page',
            pageTitle: 'Qualified Leads'
        }
    },
    {
        path: '/Companies/QualifiedLeads',
        name: 'CompanyQualifiedLeads',
        component: CompanyQualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'qualified-leads-page',
            pageTitle: 'Company Qualified Leads'
        }
    },
    {
        path: '/Clients/:clientId/Companies/QualifiedLeads',
        name: 'ClientCompanyQualifiedLeads',
        component: CompanyQualifiedLeads,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'qualified-leads-page',
            pageTitle: 'Company Qualified Leads'
        }
    },
    {
        path: '/Activities/Meetings',
        name: 'ActivityMeeting',
        component: ActivityMeeting,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'activity-meeting-page',
            pageTitle: 'Meetings'
        }
    },
    {
        path: '/Clients/:clientId/Activities/Meetings',
        name: 'ClientActivityMeeting',
        component: ActivityMeeting,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'activity-meeting-page',
            pageTitle: 'Meetings'
        }
    },
    {
        path: '/Activities/FormSubmissions',
        name: 'FormSubmissions',
        component: FormSubmissions,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'activity-form-submissions-page',
            pageTitle: 'Form Submissions'
        }
    },
    {
        path: '/Clients/:clientId/Activities/FormSubmissions',
        name: 'ClientFormSubmissions',
        component: FormSubmissions,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'activity-form-submissions-page',
            pageTitle: 'Form Submissions'
        }
    },
    {
        path: '/Videos',
        name: 'Videos',
        component: Video,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'video-index-page',
            pageTitle: 'Videos'
        }
    },
    {
        path: '/Clients/:clientId/Videos',
        name: 'ClientVideos',
        component: Video,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'video-index-page',
            pageTitle: 'Videos'
        }
    },
    //Board Begin

    {
        path: '/Contacts',
        name: 'Contacts',
        component: Contacts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-index-page',
            pageTitle: 'Contacts'
        }
    },
    {
        path: '/Clients/:clientId/Contacts',
        name: 'ClientsContacts',
        component: Contacts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-index-page',
            pageTitle: 'Contacts'
        }
    },
    //Board End
    {
        path: '/Contacts/Listless',
        name: 'ListLess',
        component: ListLess,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'contacts-listless-page',
            pageTitle: 'Contacts Without a List'
        }
    },
    {
        path: '/Clients/:clientId/Contacts/Listless',
        name: 'ClientsListLess',
        component: ListLess,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'contacts-listless-page',
            pageTitle: 'Contacts Without a List'
        }
    },
    {
        path: '/Contacts/Assigned',
        name: 'ContactAssigned',
        component: ContactAssigned,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contact-assigned-page',
            pageTitle: 'Assigned Contacts'
        }
    },
    {
        path: '/Clients/:clientId/Contacts/Assigned',
        name: 'ClientContactAssigned',
        component: ContactAssigned,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contact-assigned-page',
            pageTitle: 'Assigned Contacts'
        }
    },
    {
        path: '/Companies',
        name: 'Companies',
        component: Companies,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'companies-index-page',
            pageTitle: 'Companies'
        }
    },
    {
        path: '/Clients/:clientId/Companies',
        name: 'ClientsCompanies',
        component: Companies,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'companies-index-page',
            pageTitle: 'Companies'
        }
    },
    {
        path: '/Accounts',
        name: 'Accounts',
        component: CompanyAccounts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'accounts-index-page',
            pageTitle: 'Accounts'
        }
    },
    {
        path: '/Clients/:clientId/Accounts',
        name: 'ClientsAccounts',
        component: CompanyAccounts,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'accounts-index-page',
            pageTitle: 'Accounts'
        }
    },
    {
        path: '/SalesTeam',
        name: 'SalesTeam',
        component: SalesTeam,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'client-salesteam',
            pageTitle: 'Sales Team'
        }
    },
    {
        path: '/Clients/:clientId/SalesTeam',
        name: 'ClientsSalesTeam',
        component: SalesTeam,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'client-salesteam',
            pageTitle: 'Sales Team'
        }
    },
    {
        path: '/Opportunities',
        name: 'Opportunities',
        component: OpportunitiesDashboard,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'opportunities-dashboard-page',
            pageTitle: 'Opportunities'
        }
    },
    {
        path: '/Clients/:clientId/Opportunities',
        name: 'ClientsOpportunities',
        component: OpportunitiesDashboard,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'opportunities-dashboard-page',
            pageTitle: 'Opportunities'
        }
    },

    {
        path: '/Reports/Sales/Opportunities',
        name: 'OpportunitiesReport',
        component:ReportOpportunities,
        meta: {
            type: 'client',
            subtype: 'report',
            isUiShown: true,
            pageClass: 'opportunities-report-page',
            pageTitle: 'Opportunities Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Sales/Opportunities',
        name: 'OpportunitiesReport',
        component:ReportOpportunities,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'opportunities-dashboard-page',
            pageTitle: 'Opportunities Report'
        }
    },


    /*********** ACCOUNT SETTINGS **************/
    {
        path: '/Account/Company',
        name: 'AccountCompanySettings',
        component: AccountSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-settings-page',
            pageTitle: 'Company Settings'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Billing',
        name: 'AccountBilling',
        component: AccountBilling,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-billing-page',
            pageTitle: 'Account Billing'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Plan/Cancel',
        name: 'AccountBillingPromoCancel',
        component: AccountBillingPromoCancel,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-billing-promo-cancel-page',
            pageTitle: 'Cancel Your Account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Users',
        name: 'AccountUsersSettings',
        component: Users,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-users-settings-page',
            pageTitle: 'Account Users'
        },
        beforeEnter: (to, from, next) => {
            var isClientAdmin = store.getters.isAdmin && store.getters.isClientUser;

            if (!isClientAdmin &&
                !store.getters.isAgencyAdmin &&
                !store.getters.isMasterAgencyUser &&
                !store.getters.isOrganizationUser) {
                next('/Unauthorized');
                
            } else {
                next();
                
            }
        }
    },
    {
        path: '/Account/AllUsers',
        name: 'AccountAllUsersSettings',
        component: AllUsers,
        meta: {
            isUiShown: true,
            type:'organization',
            pageClass: 'account-users-settings-page',
            pageTitle: 'All Users'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Integrations',
        name: 'AccountIntegrationsSettings',
        component: AccountIntegrationsSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-integrations-settings-page',
            pageTitle: 'Account Integrations'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            }
            if (store.getters.isOrganizationUser) {
                next('/404');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/Signature',
        name: 'AccountCustomizationSignature',
        component: AccountCustomizationSignature,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-customization-signature-page',
            pageTitle: 'General Account Signature'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/PhoneNumbers',
        name: 'PhoneNumbers',
        component: AccountPhoneNumbers,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-phone-numbers-page',
            pageTitle: 'Phone Numbers'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/PhoneNumbers',
        name: 'ClientsPhoneNumbers',
        component: AccountPhoneNumbers,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-phone-numbers-page',
            pageTitle: 'Phone Numbers'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/Services',
        name: 'Services',
        component: ServiceIndex,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'service-index-page',
            pageTitle: 'Services'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Services',
        name: 'ClientsServices',
        component: ServiceIndex,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'service-index-page',
            pageTitle: 'Services'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CompanyTypes',
        name: 'CompanyTypes',
        component: AccountCustomizationCompanyType,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-company-types',
            pageTitle: 'Company Types'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CompanyTypes',
        name: 'ClientsCompanyTypes',
        component: AccountCustomizationCompanyType,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-company-types-page',
            pageTitle: 'Company Types'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/OpportunityTypes',
        name: 'OpportunityTypes',
        component: AccountCustomizationOpportunityType,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-types-page',
            pageTitle: 'Opportunity Types'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/OpportunityTypes',
        name: 'ClientsOpportunityTypes',
        component: AccountCustomizationOpportunityType,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-types-page',
            pageTitle: 'Opportunity Types'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/OpportunityStatuses',
        name: 'OpportunityStatuses',
        component: AccountCustomizationOpportunityStatus,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-statuses-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/OpportunityStatuses',
        name: 'ClientsOpportunityStatuses',
        component: AccountCustomizationOpportunityStatus,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-statuses-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },

    {
        path: '/Clients/:clientId/Account/Customization/OpportunityStages',
        name: 'ClientsOpportunityStages',
        component: AccountCustomizationOpportunityStages,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-stages-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },

    {
        path: '/Account/Customization/OpportunityStages',
        name: 'OpportunityStages',
        component: AccountCustomizationOpportunityStages,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-stages-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },

    {
        path: '/Clients/:clientId/Account/Customization/OpportunityStages',
        name: 'ClientsOpportunityStages',
        component: AccountCustomizationOpportunityStages,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-stages-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },

    {
        path: '/Account/Customization/OpportunityStages',
        name: 'OpportunityStages',
        component: AccountCustomizationOpportunityStages,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-opportunity-stages-page',
            pageTitle: 'Opportunity Stages'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/ContactStatuses',
        name: 'ContactStatuses',
        component: AccountCustomizationContactStatus,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-contact-statuses-page',
            pageTitle: 'Contact Statuses'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/Verticals',
        name: 'Verticals',
        component: AccountCustomizationVerticals,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-verticals-page',
            pageTitle: 'Verticals'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Categories',
        name: 'Categories',
        component: AccountCustomizationGlobalCategories,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'global-categories',
            pageTitle: 'Categories'
        }
    },
    {
        path: '/Agencies/:agencyId/Categories',
        name: 'AgencyCategories',
        component: AccountCustomizationGlobalCategories,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'global-categories',
            pageTitle: 'Categories'
        }
    },
    {
        path: '/Account/Customization/Categories',
        name: 'ClientCategories',
        component: AccountCustomizationGlobalCategories,
        meta:{
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-categories',
            pageTitle: 'Categories'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Categories',
        name: 'ClientsCategories',
        component: AccountCustomizationGlobalCategories,
        meta:{
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-categories',
            pageTitle: 'Categories'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/ContactStatuses',
        name: 'ClientsContactStatuses',
        component: AccountCustomizationContactStatus,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-contact-statuses-page',
            pageTitle: 'Contact Statuses'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Verticals',
        name: 'ClientsVerticals',
        component: AccountCustomizationVerticals,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-verticals-page',
            pageTitle: 'Verticals'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomContactFields',
        name: 'CustomContactFields',
        component: AccountCustomizationCustomContactFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-contact-fields-page',
            pageTitle: 'Custom Contact Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CustomContactFields',
        name: 'ClientsCustomContactFields',
        component: AccountCustomizationCustomContactFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-contact-fields-page',
            pageTitle: 'Custom Contact Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomCompanyFields',
        name: 'CustomCompanyFields',
        component: AccountCustomizationCustomCompanyFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-company-fields-page',
            pageTitle: 'Custom Company Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomActivityTypes',
        name: 'CustomActivityTypes',
        component: AccountCustomizationCustomLogActivities,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-log-activities-page',
            pageTitle: 'Custom Activity Types'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomOpportunityFields',
        name: 'CustomOpportunityFields',
        component: AccountCustomizationCustomOpportunityFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-opportunity-fields-page',
            pageTitle: 'Custom Opportunity Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomPartnerFields',
        name: 'CustomPartnerFields',
        component: AccountCustomizationCustomPartnerFields,
        meta: {
            type: 'agency',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-partner-fields-page',
            pageTitle: 'Custom Partner Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAgencyAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/Account/Customization/CustomPartnerFields',
        name: 'CustomPartnerFields',
        component: AccountCustomizationCustomPartnerFields,
        meta: {
            type: 'agency',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-partner-fields-page',
            pageTitle: 'Custom Partner Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAgencyAdmin &&
                !store.getters.isMasterAgencyUser &&
                !store.getters.isOrganizationUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CustomCompanyFields',
        name: 'ClientsCustomCompanyFields',
        component: AccountCustomizationCustomCompanyFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-company-fields-page',
            pageTitle: 'Custom Company Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CustomActivityTypes',
        name: 'CustomActivityTypes',
        component: AccountCustomizationCustomLogActivities,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-log-activities-page',
            pageTitle: 'Custom Activity Type'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CustomOpportunityFields',
        name: 'ClientsCustomOpportunityFields',
        component: AccountCustomizationCustomOpportunityFields,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-opportunity-fields-page',
            pageTitle: 'Custom Opportunity Fields'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Customization/CustomInsertTags',
        name: 'CustomInsertTags',
        component: AccountCustomizationCustomInsertTags,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-insert-tags-page',
            pageTitle: 'Custom Insert Tags'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/CustomInsertTags',
        name: 'ClientsCustomInsertTags',
        component: AccountCustomizationCustomInsertTags,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-custom-inset-tags-page',
            pageTitle: 'Custom Insert Tags'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Company',
        name: 'ClientAccountSettings',
        component: AccountSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-settings-page',
            pageTitle: 'Company Settings'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/Account/Company',
        name: 'AgencyAccountSettings',
        component: AccountSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-settings-page',
            pageTitle: 'Vendor Company Settings'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Account/Company',
        name: 'MasterAgencyAccountSettings',
        component: AccountSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-settings-page',
            pageTitle: 'Master Agency Company Settings'
        }
    },
    {
        path: '/Clients/:clientId/Account/Billing',
        name: 'ParentAccountBilling',
        component: AccountBilling,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'account',
            pageClass: 'account-billing-page',
            pageTitle: 'Billing'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/Account/Billing',
        name: 'AccountAgencyBilling',
        component: AccountBilling,
        meta: {
            isUiShown: true,
            type: 'agency',
            subtype: 'account',
            pageClass: 'account-billing-page',
            pageTitle: 'Vendor Billing'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Account/Billing',
        name: 'AccountMasterAgencyBilling',
        component: AccountBilling,
        meta: {
            isUiShown: true,
            type: 'master-agency',
            subtype: 'account',
            pageClass: 'account-billing-page',
            pageTitle: 'Master Agency Billing'
        }
    },
    {
        path: '/Clients/:clientId/Account/Plan/Cancel',
        name: 'ParentAccountBillingPromoCancel',
        component: AccountBillingPromoCancel,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-billing-promo-cancel-page',
            pageTitle: 'Cancel Your Account'
        }
    },
    {
        path: '/Account/EmailAuthentication',
        name: 'AccountEmailAuthentication',
        component: AccountEmailAuthentication,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-email-authentication-page',
            pageTitle: 'Email Authentication'
        }
    },
    {
        path: '/Clients/:clientId/Account/EmailAuthentication',
        name: 'ParentAccountEmailAuthentication',
        component: AccountEmailAuthentication,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-email-authentication-page',
            pageTitle: 'Email Authentication'
        }
    },
    {
        path: '/Clients/:clientId/Account/Users',
        name: 'ParentAccountUsersSettings',
        component: Users,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'account',
            pageClass: 'account-users-settings-page',
            pageTitle: 'User Settings'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Integrations',
        name: 'ParentAccountIntegrationSettings',
        component: AccountIntegrationsSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-integrations-settings-page',
            pageTitle: 'Account Integrations'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/Account/Integrations',
        name: 'AgencyAccountIntegrationSettings',
        component: AccountIntegrationsSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-integrations-settings-page',
            pageTitle: 'Account Integrations'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Account/Integrations',
        name: 'MasterAgencyAccountIntegrationSettings',
        component: AccountIntegrationsSettings,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'account-integrations-settings-page',
            pageTitle: 'Account Integrations'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Signature',
        name: 'ParentAccountCustomizationSignature',
        component: AccountCustomizationSignature,
        meta: {
            isUiShown: true,
            type: 'client',
            subtype: 'account',
            pageClass: 'account-customization-signature-page',
            pageTitle: 'General Account Signature'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Reactivate',
        name: 'ReactivateAccount',
        component: AccountReactivation,
        meta: {
            isUiShown: false,
            subtype: 'account',
            pageClass: 'account-reactivate-page',
            pageTitle: 'Account Reactivation'
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.context.client.isActive) {
                next();
            }
            else {
                next('/');
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Reactivate',
        name: 'ClientsReactivateAccount',
        component: AccountReactivation,
        meta: {
            isUiShown: false,
            subtype: 'account',
            pageClass: 'account-reactivate-page',
            pageTitle: 'Account Reactivation'
        }
    },
    {
        path: '/Agencies/:agencyId/Document/Emails/:documentId/Preview',
        name: 'AgencyEmailEditPreview',
        component: EmailPreview,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Agencies/:agencyId/Templates/:templateId/Preview',
        name: 'AgencyTemplatePreview',
        component: EmailPreview,
        props: true,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Clients/:clientId/Document/Emails/:documentId/Preview',
        name: 'ClientEmailEditPreview',
        component: EmailPreview,
        meta: {
            type: 'client',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Clients/:clientId/Templates/:templateId/preview',
        name: 'ClientTemplatePreview',
        component: EmailPreview,
        props: true,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Templates/:templateId/Preview',
        name: 'TemplatePreview',
        component: EmailPreview,
        props: true,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Integrations/Autotask/Connect',
        name: 'AutotaskIntegration',
        component: AutotaskIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Autotask Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Connect',
        name: 'ClientsAutotaskIntegration',
        component: AutotaskIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Autotask Integration'
        }
    },
    {
        path: '/Integrations/FormIntegrations/Connect',
        name: 'FormIntegration',
        component: FormIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Form Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/FormIntegrations/Connect',
        name: 'ClientsFormIntegration',
        component: FormIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Form Integration'
        }
    },
    {
        path: '/Integrations/Office365/Connect',
        name: 'Office365Integration',
        component: Office365Integration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Office 365 Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Office365/Connect',
        name: 'ClientsOffice365Integration',
        component: Office365Integration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Office 365 Integration'
        }
    },
    {
        path: '/Integrations/Dkim/Connect',
        name: 'DkimIntegration',
        component: DkimIntegration,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'DKIM Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Dkim/Connect',
        name: 'ClientsDkimIntegration',
        component: DkimIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'DKIM Integration'
        }
    },
    {
        path: '/Integrations/HubSpot',
        name: 'HubSpot',
        component: HubSpot,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'hubspot-page',
            pageTitle: 'HubSpot Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot',
        name: 'ClientsHubSpot',
        component: HubSpot,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'hubspot-page',
            pageTitle: 'HubSpot Integration'
        }
    },
    {
        path: '/Integrations/HubSpot/Connect',
        name: 'HubSpotConnect',
        component: HubSpotConnect,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'hubspot-connect-page',
            pageTitle: 'HubSpot Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Connect',
        name: 'ClientsHubSpotConnect',
        component: HubSpotConnect,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'HubSpot Integration'
        }
    },
    {
        path: '/Integrations/GoogleAnalytics/Connect',
        name: 'GoogleAnalyticsIntegration',
        component: GoogleAnalyticsIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Google Analytics Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/GoogleAnalytics/Connect',
        name: 'ClientsGoogleAnalyticsIntegration',
        component: GoogleAnalyticsIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Google Analytics Integration'
        }
    },
    {
        path: '/Integrations/CampaignMonitor/Connect',
        name: 'CampaignMonitorIntegration',
        component: CampaignMonitorIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Campaign Monitor Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/CampaignMonitor/Connect',
        name: 'ClientsCampaignMonitorIntegration',
        component: CampaignMonitorIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Campaign Monitor Integration'
        }
    },
    {
        path: '/Integrations/Wistia/Connect',
        name: 'WistiaIntegration',
        component: WistiaIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Wistia Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Wistia/Connect',
        name: 'ClientsWistiaIntegration',
        component: WistiaIntegration,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-setups',
            pageTitle: 'Wistia Integration'
        }
    },
    {
        path: '/RegisteredDeals',
        name: 'RegisteredDealIndex',
        component: RegisteredDealIndex,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'registered-deal-index-page',
            pageTitle: 'Registered Deals'
        },
        beforeEnter: (to, from, next) => {
            if (store.getters.isMasterAgencyUser) {
                next('/Agencies');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/RegisteredDeals',
        name: 'AgencyRegisteredDealIndex',
        component: RegisteredDealIndex,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'registered-deal-index-page',
            pageTitle: 'Vendor Registered Deals'
        }
    },
    {
        path: '/Templates/Create',
        name: 'TemplateCreate',
        component: TemplateCreate,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'templates-create-page',
            pageTitle: 'Graphical Email Template Creation'
        }
    },
    {
        path: '/Agencies/:agencyId/Templates/Create',
        name: 'AgencyTemplateCreate',
        component: TemplateCreate,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'templates-create-page',
            pageTitle: 'Vendor Graphical Email Template Creation'
        }
    },
    {
        path: '/Clients/:clientId/Templates/Create',
        name: 'ClientsTemplateCreate',
        component: TemplateCreate,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'templates-create-page',
            pageTitle: 'Graphical Template Creation'
        }
    },
    {
        path: '/Campaigns/:campaignId',
        name: 'CampaignDetail',
        component: CampaignDetail,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'campaigns-details-page',
            pageTitle: 'Campaign Details'
        }
    },
    {
        path: '/Account/Login',
        name: 'AccountGateway',
        component: AccountGateway,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Login'
        }
    },
    {
        path: '/Account/Signup',
        name: 'AccountSignup',
        component: AccountGateway,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Sign Up'
        }
    },
    {
        path: '/ConnectWise',
        name: 'AccountSignupCW',
        component: AccountGateway,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Sign Up'
        }
    },
    {
        path: '/MS-CW',
        name: 'AccountSignupMSCW',
        component: AccountGateway,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Sign Up'
        }
    },
    {
        path: '/PartnerProgram/Connectwise',
        name: 'PartnerProgramCW',
        component: AccountGateway,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Login'
        }
    },
    {
        path: '/Account/ConfirmEmail',
        name: 'ConfirmEmail',
        component: AccountConfirmEmail,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'confirm-page',
            pageTitle: 'Email Confirmation'
        }
    },
    {
        path: '/Account/ConfirmationRequired',
        name: 'ConfirmationRequired',
        component: AccountConfirmationRequired,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'confirmation-email-required-page',
            pageTitle: 'Confirmation Required'
        }
    },
    {
        path: '/Account/ResendConfirmationEmail',
        name: 'ResendConfirmationEmail',
        component: AccountResendConfirmationEmail,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'resend-confirmation-email-page',
            pageTitle: 'Resend Confirmation'
        }
    },
    {
        path: '/Contacts/Bounced',
        name: 'ContactsBounced',
        component: ContactsBounced,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-bounced-page',
            pageTitle: 'Bounced Contacts'
        }
    },

    {
        path: '/Clients/:clientId/Contacts/Bounced',
        name: 'ClientsContactsBounced',
        component: ContactsBounced,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-bounced-page',
            pageTitle: 'Bounced Contacts'
        }
    },

    {
        path: '/Contacts/Unsubscribed',
        name: 'ContactsUnsubscribed',
        component: ContactsUnsubscribed,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-unsubscribed-page',
            pageTitle: 'Unsubscribed Contacts'
        }
    },
    {
        path: '/Clients/:clientId/Contacts/Unsubscribed',
        name: 'ClientsContactsUnsubscribed',
        component: ContactsUnsubscribed,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-unsubscribed-page',
            pageTitle: 'Unsubscribed Contacts'
        }
    },
    {
        path: '/Contacts/Merge',
        name: 'ClientContactsMerge',
        component: ContactMerge,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'contacts-merge-page',
            pageTitle: 'Contact Merge'
        }
    },
    {
        path: '/Clients/:clientId/Contacts/Merge',
        name: 'ContactsMerge',
        component: ContactMerge,
        meta: {
            type: 'client',
            subtype: 'shared',
            isUiShown: true,
            pageClass: 'contacts-merge-page',
            pageTitle: 'Contact Merge'
        }
    },
    {
        path: '/UserGuide',
        name: 'UserGuide',
        component: UserGuide,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'user-guide-page',
            pageTitle: 'User Guide'
        }
    },
    {
        path: '/Clients/:clientId/UserGuide',
        name: 'ClientUserGuide',
        component: UserGuide,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'user-guide-page',
            pageTitle: 'User Guide'
        }
    },
    {
        path: '/Companies/:companyId',
        name: 'CompanyDetail',
        component: CompanyDetail,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'companies-details-page',
            pageTitle: 'Company Details'
        }
    },
    {
        path: '/Profile/Personal',
        name: 'ProfilePersonalSettings',
        component: ProfilePersonalSettings,
        meta: {
            type: 'general',
            subtype: 'profile',
            isUiShown: true,
            pageClass: 'profile-settings-page',
            pageTitle: 'Profile'
        }
    },
    {
        path: '/Profile/Email',
        name: 'ProfileEmailSettings',
        component: ProfileEmailSettings,
        meta: {
            type: 'general',
            subtype: 'profile',
            isUiShown: true,
            pageClass: 'profile-email-page',
            pageTitle: 'Email Settings'
        }
    },
    {
        path: '/NextSteps',
        name: 'NextSteps',
        component: NextSteps,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'next-steps-page',
            pageTitle: 'GlassHive Setup'
        }
    },
    {
        path: '/Account/ForgotPassword',
        name: 'AccountForgotPassword',
        component: AccountForgotPassword,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: '',
            pageTitle: 'Forgot Password'
        }
    },
    {
        path: '/Account/ResetPasswordConfirmation',
        name: 'AccountResetPasswordConfirmation',
        component: AccountResetPasswordConfirmation,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Reset Password Confirmation'
        }
    },
    {
        path: '/Account/ResetPassword',
        name: 'AccountResetPassword',
        component: AccountResetPassword,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'account-reset-password-page',
            pageTitle: 'Reset Password'
        }
    },
    {
        path: '/Account/ForgotPasswordConfirmation',
        name: 'AccountForgotPasswordConfirmation',
        component: AccountForgotPasswordConfirmation,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'login-page',
            pageTitle: 'Forgot Password Confirmation'
        }
    },
    {
        path: '/Account/ProSignUp',
        name: 'AccountProSignup',
        component: AccountProSignup,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'account-pro-signup-page',
            pageTitle: 'Sign Up'
        }
    },
    {
        path: '/Account/TermsOfService',
        name: 'TermsOfService',
        component: TermsOfService,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'disclaimer',
            pageTitle: 'Terms of Service'
        }
    },
    {
        path: '/Account/AiTransparency',
        name: 'AiTransparency',
        component: AiTransparency,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'disclaimer',
            pageTitle: 'AI Transparency Disclosure'
        }
    },
    {
        path: '/Account/DPA',
        name: 'DataProcessingAgreement',
        component: DataProcessingAgreement,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'disclaimer',
            pageTitle: 'Data Processing Agreement'
        }
    },
    {
        path: '/Account/CookiePolicy',
        name: 'CookiePolicy',
        component: CookiePolicy,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'disclaimer',
            pageTitle: 'Cookie Policy'
        }
    },
    {
        path: '/Account/PrivacyPolicy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'disclaimer',
            pageTitle: 'Privacy Policy'
        }
    },
    {
        path: '/Campaigns/:campaignId/Preview',
        name: 'CampaignPreview',
        component: EmailPreview,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/CampaignTemplates/:campaignTemplateId/Preview',
        name: 'CampaignTemplatePreview',
        component: EmailPreview,
        meta: {
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Clients/:clientId/CampaignTemplates/:campaignTemplateId/Preview',
        name: 'ClientCampaignTemplatePreview',
        component: EmailPreview,
        props: true,
        meta: {
            isUiShown: false,
            pageClass: 'email-preview-page',
            pageTitle: 'Email Preview'
        }
    },
    {
        path: '/Lists/:listId/',
        name: 'List',
        component: List,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'lists-details-page',
            pageTitle: 'Lists'
        }
    },
    {
        path: '/SalesTeam/:salesPersonId',
        name: 'salesPersonDetail',
        component: SalesPersonDetail,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'clients-sales-professional-page',
            pageTitle: 'Sales Person'
        }
    },
    {
        path: '/Clients/:clientId/Templates/:templateId/Edit',
        name: 'ClientsTemplateEdit',
        component: TemplateEdit,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'templates-edit-page',
            pageTitle: 'Edit Template'
        }
    },
    {
        path: '/Agencies/:agencyId/Templates/:templateId/Edit',
        name: 'AgencyTemplateEdit',
        component: TemplateEdit,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'templates-edit-page',
            pageTitle: 'Edit Graphical Campaign Template'
        }
    },
    {
        path: '/Templates/:templateId/Edit',
        name: 'TemplateEdit',
        component: TemplateEdit,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'templates-edit-page',
            pageTitle: 'Edit Graphical Campaign Template'
        }
    },
    {
        path: '/Contacts/:contactId',
        name: 'Contact',
        component: NewContactDetail,
        meta: {
            type: 'client',
            subtype: 'contacts',
            isUiShown: true,
            pageClass: 'new-contacts-details-page',
            pageTitle: 'Contact Details'
        }
    },
    {
        path: '/MarketingPlans',
        name: 'MarketingPlans',
        component: MarketingPlans,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-index-page',
            pageTitle: 'Marketing Plans'
        }
    },
    {
        path: '/Account/Upgrade/MarketingPlans',
        name: 'MarketingPlanAccountUpgrade',
        component: MarketingPlanAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-marketing-plan-page',
            pageTitle: 'Account Upgrade Marketing Plan'
        }
    },
    {
        path: '/Clients/:clientId/Account/Upgrade/MarketingPlans',
        name: 'ClientMarketingPlanAccountUpgrade',
        component: MarketingPlanAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-marketing-plan-page',
            pageTitle: 'Account Upgrade Marketing Plan'
        }
    },

    {
        path: '/Account/Upgrade/MarketingPlanTemplates',
        name: 'MarketingPlanTemplatesAccountUpgrade',
        component: MarketingPlanAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-marketing-plan-page',
            pageTitle: 'Account Upgrade Marketing Plan'
        }
    },
    {
        path: '/Clients/:clientId/Account/Upgrade/MarketingPlanTemplates',
        name: 'ClientMarketingPlanTemplatesAccountUpgrade',
        component: MarketingPlanAccountUpgrade,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'account-upgrade-marketing-plan-page',
            pageTitle: 'Account Upgrade Marketing Plan'
        }
    },

    {
        path: '/Clients/:clientId/MarketingPlans',
        name: 'ClientMarketingPlans',
        component: MarketingPlans,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-index-page',
            pageTitle: 'Marketing Plans'
        }
    },
    {
        path: '/Agencies/:agencyId/MarketingPlans',
        name: 'AgencyMarketingPlans',
        component: MarketingPlans,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-index-page',
            pageTitle: 'Marketing Plans'
        }
    },
    {
        path: '/MarketingPlanTemplates',
        name: 'MarketingPlanTemplates',
        component: MarketingPlanTemplates,
        meta: {
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-template-index-page',
            pageTitle: 'Marketing Plan Templates'
        }
    },
    {
        path: '/Clients/:clientId/MarketingPlanTemplates',
        name: 'ClientMarketingPlanTemplates',
        component: MarketingPlanTemplates,
        meta: {
            type: 'client',
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-template-index-page',
            pageTitle: 'Marketing Plan Templates'
        }
    },
    {
        path: '/Agencies/:agencyId/MarketingPlanTemplates',
        name: 'AgencyMarketingPlanTemplates',
        component: MarketingPlanTemplates,
        meta: {
            subtype: 'automation',
            isUiShown: true,
            pageClass: 'marketing-plan-template-index-page',
            pageTitle: 'Marketing Plan Templates'
        }
    },
    {
        path: '/Reports',
        name: 'ReportIndex',
        component: ReportIndex,
        meta: {
            isUiShown: true,
            pageClass: 'report-index-page',
            pageTitle: 'Reports'
        }
    },
    {
        path: '/ScheduledReports',
        name: 'ReportAgencyScheduledReport',
        component: ReportAgencyScheduledReports,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'report-schedule-page',
            pageTitle: 'Scheduled Reports'
        }
    },
    {
        path: '/Agencies/:agencyId/ScheduledReports',
        name: 'AgenciesReportAgencyScheduledReport',
        component: ReportAgencyScheduledReports,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'report-schedule-page',
            pageTitle: 'Scheduled Reports'
        }
    },
    {
        path: '/Reports/RegisteredDeals',
        name: 'ReportAgencyRegisteredDealsReport',
        component: ReportAgencyRegisteredDealsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-registered-deals-report-page',
            pageTitle: 'Registered Deals Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/RegisteredDeals',
        name: 'AgenciesReportAgencyRegisteredDealsReport',
        component: ReportAgencyRegisteredDealsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-registered-deals-report-page',
            pageTitle: 'Registered Deals Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/Usage',
        name: 'AgenciesReportUsageReport',
        component: ReportAgencyUsageReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-usage-report-page',
            pageTitle: 'Usage Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/Usage',
        name: 'UsageReport',
        component: ReportAgencyUsageReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-usage-report-page',
            pageTitle: 'Usage Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/PartnerSurveys',
        name: 'AgenciesReportPartnerSurveysReport',
        component: ReportAgencyPartnerSurveysReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-surveys-report-page',
            pageTitle: 'Partner Surveys Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/PartnerSurveys',
        name: 'PartnerSurveysReport',
        component: ReportAgencyPartnerSurveysReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-surveys-report-page',
            pageTitle: 'Partner Surveys Report'
        }
    },
    {
        path: '/Reports/MDF',
        name: 'ReportAgencyMDFReport',
        component: ReportMDFIndex,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-mdf-report-page',
            pageTitle: 'MDF Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/MDF',
        name: 'AgenciesReportAgencyMDFReport',
        component: ReportMDFIndex,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-mdf-report-page',
            pageTitle: 'MDF Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/RegisteredDeals',
        name: 'ParentReportMasterAgencyRegisteredDealsReport',
        component: ReportMasterAgencyRegisteredDealsReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-registered-deals-page',
            pageTitle: 'Registered Deals Report'
        }
    },
    {
        path: '/Reports/MasterAgencyRegisteredDeals',
        name: 'ReportMasterAgencyRegisteredDealsReport',
        component: ReportMasterAgencyRegisteredDealsReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-registered-deals-page',
            pageTitle: 'Registered Deals Report'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/PartnerResources',
        name: 'ParentReportMasterAgencyPartnerResourcesReport',
        component: ReportMasterAgencyPartnerResourcesReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-partner-resources-page',
            pageTitle: 'Partner Resources Report'
        }
    },
    {
        path: '/Reports/MasterAgencyPartnerResources',
        name: 'ReportMasterAgencyPartnerResourcesReport',
        component: ReportMasterAgencyPartnerResourcesReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-partner-resources-page',
            pageTitle: 'Partner Resources Report'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/TopAgencies',
        name: 'ParentReportMasterAgencyTopAgencies',
        component: ReportMasterAgencyTopAgencies,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-top-agencies-page',
            pageTitle: 'Master Agency Top Vendors Report'
        }
    },
    {
        path: '/Reports/TopAgencies',
        name: 'ReportMasterAgencyTopAgencies',
        component: ReportMasterAgencyTopAgencies,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-top-agencies-page',
            pageTitle: 'Master Agency Top Vendors Report'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/TopPartners',
        name: 'ParentReportMasterAgencyTopPartners',
        component: ReportMasterAgencyTopPartners,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-top-partners-page',
            pageTitle: 'Master Agency Top Partners Report'
        }
    },
    {
        path: '/Reports/MasterAgencyTopPartners',
        name: 'ReportMasterAgencyTopPartners',
        component: ReportMasterAgencyTopPartners,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-top-partners-page',
            pageTitle: 'Master Agency Top Partners Report'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Reports/Leads',
        name: 'ParentReportMasterAgencyLeads',
        component: ReportMasterAgencyLeadsReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-leads-page',
            pageTitle: 'Master Agency Leads Report'
        }
    },
    {
        path: '/Reports/Leads',
        name: 'ReportMasterAgencyLeads',
        component: ReportMasterAgencyLeadsReport,
        meta: {
            type: 'general',
            isUiShown: true,
            pageClass: 'report-master-agency-leads-page',
            pageTitle: 'Master Agency Leads Report'
        }
    },
    {
        path: '/Reports/PartnerLeads',
        name: 'ReportAgencyPartnerLeadsReport',
        component: ReportAgencyPartnerLeadsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-leads-report-page',
            pageTitle: 'Partner Leads Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/PartnerLeads',
        name: 'AgenciesReportAgencyPartnerLeadsReport',
        component: ReportAgencyPartnerLeadsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-leads-report-page',
            pageTitle: 'Partner Leads Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/PartnerResources',
        name: 'ReportAgencyPartnerResourcesReport',
        component: ReportAgencyPartnerResourcesReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-resources-report-page',
            pageTitle: 'Partner Resources Report - Emails'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/PartnerResources',
        name: 'AgenciesReportAgencyPartnerResourcesReport',
        component: ReportAgencyPartnerResourcesReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-resources-report-page',
            pageTitle: 'Partner Resources Report - Emails'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/Marketing',
        name: 'ReportMarketing',
        component: ReportMarketing,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-page',
            pageTitle: 'Marketing Reports'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing',
        name: 'ClientsReportMarketing',
        component: ReportMarketing,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-page',
            pageTitle: 'Marketing Reports'
        }
    },
    {
        path: '/Reports/Marketing/Leads',
        name: 'ReportMarketingLeadsReport',
        component: ReportMarketingLeadsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-leads-report-page',
            pageTitle: 'Marketing Leads Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/Leads',
        name: 'ClientsReportMarketingLeadsReport',
        component: ReportMarketingLeadsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-leads-report-page',
            pageTitle: 'Marketing Leads Report'
        }
    },
    {
        path: '/Reports/Marketing/WebsiteAnalytics',
        name: 'ReportMarketingWebsiteAnalyticsReport',
        component: ReportMarketingWebsiteAnalyticsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-marketing-website-analytics-report-page',
            pageTitle: 'Marketing Website Analytics Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/WebsiteAnalytics',
        name: 'ClientsReportMarketingWebsiteAnalyticsReport',
        component: ReportMarketingWebsiteAnalyticsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-marketing-website-analytics-report-page',
            pageTitle: 'Marketing Website Analytics Report'
        }
    },
    {
        path: '/Reports/Marketing/Campaigns',
        name: 'ReportMarketingCampaignsReport',
        component: ReportMarketingCampaignsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-campaigns-report-page',
            pageTitle: 'Marketing Campaigns Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/Campaigns',
        name: 'ClientsReportMarketingCampaignsReport',
        component: ReportMarketingCampaignsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-campaigns-report-page',
            pageTitle: 'Marketing Campaigns Report'
        }
    },
    {
        path: '/Reports/Marketing/LandingPages',
        name: 'ReportMarketingLandingPagesReport',
        component: ReportMarketingLandingPagesReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-landing-pages-report-page',
            pageTitle: 'Marketing Landing Pages Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/LandingPages',
        name: 'ClientsReportMarketingLandingPagesReport',
        component: ReportMarketingLandingPagesReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-landing-pages-report-page',
            pageTitle: 'Marketing Landing Pages Report'
        }
    },
    {
        path: '/Reports/Marketing/MarketingPlans',
        name: 'ReportMarketingMarketingPlansReport',
        component: ReportMarketingMarketingPlansReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-marketing-plans-report-page',
            pageTitle: 'Marketing Plans Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/MarketingPlans',
        name: 'ClientsReportMarketingMarketingPlansReport',
        component: ReportMarketingMarketingPlansReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-marketing-plans-report-page',
            pageTitle: 'Marketing Plans Report'
        }
    },
    {
        path: '/Reports/Marketing/FormSubmissions',
        name: 'ReportMarketingFormSubmissionsReport',
        component: ReportMarketingFormSubmissionsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-form-submissions-report-page',
            pageTitle: 'Form Submissions Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Marketing/FormSubmissions',
        name: 'ClientsReportMarketingFormSubmissionsReport',
        component: ReportMarketingFormSubmissionsReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-form-submissions-report-page',
            pageTitle: 'Form Submissions Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/MDF',
        name: 'ClientsReportMarketingMDF',
        component: ReportMDFIndex,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'reports-marketing-form-submissions-report-page',
            pageTitle: 'MDF Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Marketing/Calendar',
        name: 'AgencyMarketingCalendar',
        component: MarketingPlanCalendar,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'marketing-plan-calendar-page',
            pageTitle: 'Marketing Plan Calendar'
        }
    },
    {
        path: '/MarketingPlans/:marketingPlanId/Calendar',
        name: 'MarketingPlanCalendar',
        component: MarketingPlanCalendar,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'marketing-plan-calendar-page',
            pageTitle: 'Marketing Plan Calendar'
        }
    },
    {
        path: '/Clients/:clientId/Marketing/Calendar',
        name: 'ClientMarketingCalendar',
        component: MarketingPlanCalendar,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'marketing-plan-calendar-page',
            pageTitle: 'Marketing Plan Calendar'
        }
    },
    {
        path: '/Marketing/Calendar',
        name: 'Calendar',
        component: MarketingPlanCalendar,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'marketing-plan-calendar-page',
            pageTitle: 'Marketing Plan Calendar'
        }
    },
    {
        path: '/MarketingPlanTemplates/:marketingPlanTemplateId/Calendar',
        name: 'MarketingPlanTemplatesCalendar',
        component: MarketingPlanTemplateCalendar,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'marketing-plan-template-calendar-page',
            pageTitle: 'Marketing Plan Template Calendar'
        }
    },
    {
        path: '/Reports/Sales',
        name: 'ReportSales',
        component: ReportSales,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-page',
            pageTitle: 'Sales Reports'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Sales',
        name: 'ClientsReportSales',
        component: ReportSales,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-page',
            pageTitle: 'Sales Reports'
        }
    },
    {
        path: '/Reports/Sales/Activity',
        name: 'ReportSalesTeamActivity',
        component: ReportSalesTeamActivity,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-team-activity-page',
            pageTitle: 'Sales Team Activity Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Sales/Activity',
        name: 'ClientReportSalesTeamActivity',
        component: ReportSalesTeamActivity,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-team-activity-page',
            pageTitle: 'Sales Team Activity Report'
        }
    },
    {
        path: '/Reports/Sales/Performance',
        name: 'ReportSalesPerformanceReport',
        component: ReportSalesPerformanceReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-performance-report-page',
            pageTitle: 'Sales Performance Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Sales/Performance',
        name: 'ClientsReportSalesPerformanceReport',
        component: ReportSalesPerformanceReport,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-performance-report-page',
            pageTitle: 'Sales Performance Report'
        }
    },
    {
        path: '/Clients/:clientId/OpportunitiesDashboard',
        name: 'OpportunitiesDashboard',
        component: OpportunitiesDashboard,
        meta: {
            type: 'client',
            subtype: 'opportunities',
            isUiShown: true,
            pageClass: 'opportunities-dashboard-page',
            pageTitle: 'Opportunities Dashboard'
        }
    },
    {
        path: '/Reports/Sales/ClientSolutionsRoadmap',
        name: 'ReportSalesClientSolutionsRoadmapReport',
        component: ReportSalesClientSolutionsRoadmap,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-client-solutions-roadmap-page',
            pageTitle: 'Client Solutions Roadmap Report'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Sales/ClientSolutionsRoadmap',
        name: 'ClientsReportSalesClientSolutionsRoadmapReport',
        component: ReportSalesClientSolutionsRoadmap,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-sales-client-solutions-roadmap-page',
            pageTitle: 'Client Solutions Roadmap Report'
        }
    },
    {
        path: '/Reports/Scheduled',
        name: 'ReportsScheduled',
        component: ReportsScheduled,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-schedule-page',
            pageTitle: 'Scheduled Reports'
        }
    },
    {
        path: '/Clients/:clientId/Reports/Scheduled',
        name: 'ClientsReportsScheduled',
        component: ReportsScheduled,
        meta: {
            type: 'client',
            subtype: 'reports',
            isUiShown: true,
            pageClass: 'report-schedule-page',
            pageTitle: 'Scheduled Reports'
        }
    },
    {
        path: '/Updates',
        name: 'Updates',
        component: Updates,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'updates-page',
            pageTitle: 'Updates'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isOrganizationUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Account/Partners',
        name: 'Partners',
        component: PartnerApplicationAccessClient,
        meta: {
            type: 'client',
            isUiShown: true,
            subtype: 'account',
            pageClass: 'partner-application-access-client-page',
            pageTitle: 'Partners'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Partners',
        name: 'PartnersClientView',
        component: PartnerApplicationAccessClient,
        meta: {
            type: 'agency',
            isUiShown: true,
            subtype: 'account',
            pageClass: 'partner-application-access-client-page',
            pageTitle: 'Partners'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Reports/PartnerResourcesSolutions',
        name: 'ReportAgencyPartnerResourcesSolutionsReport',
        component: ReportAgencyPartnerResourcesSolutionsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-resources-solutions-report-page',
            pageTitle: 'Partner Resources Solutions Report'
        }
    },
    {
        path: '/Agencies/:agencyId/Reports/PartnerResourcesSolutions',
        name: 'AgenciesReportAgencyPartnerResourcesSolutionsReport',
        component: ReportAgencyPartnerResourcesSolutionsReport,
        meta: {
            type: 'agency',
            subtype: 'agency-reports',
            isUiShown: true,
            pageClass: 'reports-agency-partner-resources-solutions-report-page',
            pageTitle: 'Partner Resources Solutions Report'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isParentUser) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },

    {
        path: '/Clients/:clientId/PrivacyEnabled/:accountId',
        name: 'PrivacyEnabled',
        component: AccountPrivacyEnabledView,
        meta: {
            isUiShown: false,
            subtype: 'account'
        },
        props: true
    },

    /*****Redirects ********/
    {
        path: '/Account/Settings',
        name: 'RedirectAccountCompanySettings',
        redirect: '/Account/Company'
    },
    {
        path: '/Clients/:clientId/Account/Settings',
        name: 'ParentRedirectAccountCompanySettings',
        redirect: '/Clients/:clientId/Account/Company'
    },
    {
        path: '/Unauthorized',
        component: Unauthorized
    },
    {
        path: '/404',
        component: NotFound
    },
    {
        path: '*',
        component: NotFound
    }
];
